(() => {
  document.documentElement.classList.add('sq-js');

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#sculptique-product-top"]');
    if (!link) return;
    const target = document.getElementById('sculptique-product-top');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });

  /*
   * Most Shopify themes register <product-form> and own the add-to-cart flow.
   * This fallback runs only when that native controller is absent. It still uses
   * an existing theme cart drawer/notification when one exposes Shopify's
   * renderContents API; otherwise it sends the shopper to the normal cart page.
   */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.sq-product__form');
    if (!form || event.defaultPrevented || customElements.get('product-form')) return;

    event.preventDefault();
    const button = form.querySelector('[name="add"]');
    const cart = document.querySelector('cart-notification, cart-drawer');
    const formData = new FormData(form);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add this selection to the cart.');
      }

      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(result);
        if (typeof cart.open === 'function') cart.open();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: result } }));
      } else {
        window.location.assign(window.routes?.cart_url || '/cart');
      }
    } catch (error) {
      window.alert(error.message);
    } finally {
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
})();
